<template>
    <div @click="show()" v-if="recipient"
        class="input_banks flex flex-row cursor-pointer relative w-full mt-2 mb-3 py-3 px-2 mb-3 surface-border border-2 border-round-2xl justify-content-left align-items-center overflow-hidden gap-2">
        <div class="flex">
            <AvatarGroup>
                <Avatar v-if="recipient.bank_code" :image="getBankImage(recipient.bank_code)" class="w-full surface-0" shape="circle"/>
                <Avatar v-else :image="getPaySysImage(recipient.payment_system_code)" class="w-full surface-0" shape="circle"/>
            </AvatarGroup>
        </div>
        <div class="flex-1 flex flex-column gap-2 justify-content-center">
            <div class="w-full flex flex-row gap-1 overflow-hidden white-space-nowrap">
                <span v-if="recipient.fields && recipient.fields.fullname" 
                    class="flex font-medium text-sm xl:text-md">
                    {{ recipient.fields.fullname }}
                </span>
                <i class="pi pi-verified text-600 text-primary text-xs"></i>
            </div>
            <div class="w-full flex flex-row gap-1 overflow-hidden font-base text-500 text-sm xl:text-md white-space-nowrap">
                <span v-if="recipient.bank_code" class="text-500 mr-1">
                    {{ getBankTitle(recipient.bank_code) }}
                </span>
                <div v-if="recipient.fields && (recipient.fields.account_number || recipient.fields.card_number || recipient.fields.phone_number || recipient.fields.telegram || recipient.fields.wallet_address)"class="flex">
                    {{  (recipient.fields.account_number) ? recipient.fields.account_number : 
                        (recipient.fields.card_number) ? formatCardNumber(recipient.fields.card_number) : 
                        (recipient.fields.phone_number) ? recipient.fields.phone_number : 
                        (recipient.fields.telegram) ? `Tg: ${recipient.fields.telegram}` : 
                        (recipient.fields.wallet_address) ? getShort(recipient.fields.wallet_address, 30) : '' }}
                </div>
            </div>
        </div>
        <i class="pi pi-chevron-down text-600 absolute right-0 mr-0 surface-50 p-2 border-circle mr-2 deep_white_shadow"></i>
    </div>

    <Dialog v-if="loaded && recipients" v-model:visible="recipients_popup" modal
        class="w-full border-round-xl overflow-hidden border-none surface-100"
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : 'max-w-30rem'">

        <template #header>
            <span class="text-lg font-medium">{{ lang('choose_recipient') }}</span>
        </template>

        <div class="flex flex-column gap-3 xl:py-4 xl:px-1 lg:py-3 md:py-2">
            <MobMenu :headerTxt="lang('choose_recipient')">
                <template v-slot:body>
                    <div v-for="item of recipients" @click="choose(item)"
                        class="w-full relative flex flex-row gap-2 px-3 py-2 border-100 cursor-pointer border-bottom-1" style="min-height:65px">
                        <div class="flex flex-row flex-1 gap-2">
                            <div class="flex">
                                <AvatarGroup>
                                    <Avatar v-if="item.bank_code":image="getBankImage(item.bank_code)" class="w-full surface-0" shape="circle"/>
                                    <Avatar v-else :image="getPaySysImage(item.payment_system_code)" class="w-full surface-0" shape="circle"/>
                                </AvatarGroup>
                            </div>
                            <div class="flex-1 flex flex-column gap-2 justify-content-center">
                                <div class="w-full flex flex-row gap-1 overflow-hidden white-space-nowrap">
                                    <span v-if="item.fields && item.fields.fullname" 
                                        class="flex font-medium text-sm xl:text-md">
                                        {{ item.fields.fullname }}
                                    </span>
                                    <i class="pi pi-verified text-600 text-primary text-xs"></i>
                                </div>
                                <div class="w-full flex flex-row gap-1 overflow-hidden font-base text-500 text-sm xl:text-md white-space-nowrap">
                                    <span v-if="item.bank_code" class="flex">
                                        {{ getBankTitle(item.bank_code) }}
                                    </span>
                                    <div v-if="item.fields && (item.fields.account_number || item.fields.card_number || item.fields.phone_number || item.fields.telegram || item.fields.wallet_address)"
                                        class="flex">
                                        <span v-if="item.fields.account_number">{{ item.fields.account_number }}</span>
                                        <span v-else-if="item.fields.card_number">{{ formatCardNumber(item.fields.card_number) }}</span>
                                        <span v-else-if="item.fields.phone_number">{{ item.fields.phone_number }}</span>
                                        <span v-else-if="item.fields.telegram">Tg: {{ item.fields.telegram }}</span>
                                        <span v-else-if="item.fields.wallet_address">{{ getShort(item.fields.wallet_address, 30) }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="absolute right-0 top-0 bottom-0 flex justify-content-center align-items-center mr-3">
                            <div class="surface-border border-1 border-circle surface-0 deep_white_shadow">
                                <div class="border-circle" style="width:18px;height:18px;margin:3px" :class="{'bg-green-400': isCurrent(item), 'surface-0': isCurrent(item)}"></div>
                            </div>
                        </div>
                    </div>
                </template>
            </MobMenu>
        </div>
    </Dialog>
</template>

<script>
import MobMenu from '@/components/sides/menu/MobMenu.vue'
import Helper from '@/assets/js/Helper.js'
import { PaymentSystemList, BankList, Bank } from '@/assets/js/classes/PaymentSystem.js'

export default {
    name: 'RecipientsDropdown',
    props: {
        recipients: {
            type: Array,
            default: () => []
        },
        recipient: {
            type: Object,
            default: () => ({})
        },
        pay_list: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            recipients_popup: false,
            loaded: true,
            bankList: []
        }
    },
    components: {
        MobMenu,
    },
    methods: {
        lang(value){ return this.$t(`views.transfer.${value}`)},
        getPaySysImage(code){
            if(!this.pay_list) return null
            const ps = this.pay_list.find(item=>item.code===code)
            return (ps && ps.image) ? ps.image : null
        },
        getBankTitle(code){
            let bankObj = new BankList()
            bankObj.items = this.bankList
            const bankCode = bankObj.GetTitle(code, this.lang_)
            return (bankCode) ? bankCode : code
        },
        getBankImage(code){
            let bankObj = new BankList()
            bankObj.items = this.bankList
            const bankCode = bankObj.GetImage(code)
            return (bankCode) ? bankCode : code
        },
        formatCardNumber(val){
            return this.helper.format_card(val)
        },
        show(){
            this.recipients_popup = true
        },
        choose(item){
            this.$emit('update:recipient', item)
            this.recipients_popup = false
        },
        getShort(val, length=20){
            return this.helper.get_short_name(val, length)
        },
        isCurrent(item){
            return (this.recipient && item.id === this.recipient.id)
        },
    },
    computed: {
        screenSize() { return this.$store.getters.StateScreenSize },
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
    },
    beforeCreate() {
        this.helper = new Helper()
    },
    async mounted() {
        this.bankList = await BankList.GetList(this.$store).then(res => res)
    },
}
</script>
